import classNames from 'classnames';

const Facebook = ({ className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('icon', className)}
  >
    <title>Facebook</title>
    <g fillRule="evenodd">
      <path
        fill="currentColor"
        d="M15.9377427,13.1067961 L16.461165,9.69417476 L13.1868932,9.69417476 L13.1868932,7.47959102 C13.1868932,6.54596238 13.6442536,5.63592233 15.1108277,5.63592233 L16.5995146,5.63592233 L16.5995146,2.73058252 C16.5995146,2.73058252 15.2484624,2.5 13.9568083,2.5 C11.2600995,2.5 9.49757282,4.13436893 9.49757282,7.09320388 L9.49757282,9.69417476 L6.5,9.69417476 L6.5,13.1067961 L9.49757282,13.1067961 L9.49757282,21.3565777 C10.0986323,21.4508859 10.7146796,21.5 11.342233,21.5 C11.9697864,21.5 12.5858337,21.4508859 13.1868932,21.3565777 L13.1868932,13.1067961 L15.9377427,13.1067961"
      />
    </g>
  </svg>
);

Facebook.propTypes = {
  className: PropTypes.string,
};

export default Facebook;
